import constants from '../../config/constants.ts'

const classbookStatusFlagMixin = {
  methods: {
    getClassbookStatusBadge (title, type) {
      const { read, missing_parents, contacted, updated } = constants.classbook.absences.status

      if (type === missing_parents) {
        return {
          icon: 'icon-info',
          color: 'danger',
          text: title,
          testId: `badge-${type.toLowerCase()}`
        }
      }
      if (type === read) {
        return {
          icon: 'icon-check-double-o-16',
          color: 'info-dark',
          text: title,
          outline: true,
          testId: `badge-${type.toLowerCase()}`
        }
      }
      if (type === updated) {
        return {
          icon: 'icon-info',
          color: 'warning',
          text: title,
          testId: `badge-${type.toLowerCase()}`
        }
      }
      if (type === contacted) {
        return {
          icon: 'icon-check-o-16',
          color: 'gray-300',
          text: title,
          outline: true,
          testId: `badge-${type?.toLowerCase()}`
        }
      }

      return {
        icon: 'icon-info',
        color: 'gray-300',
        text: title,
        testId: `badge-${type?.toLowerCase()}`
      }
    }
  }
}

export default classbookStatusFlagMixin
